import React, { useState, useEffect } from "react";
import "./Plans.css";
import "../../App.css";
import Yearly from "./Yearly";
import Monthly from "./Monthly";
import { getCurrency } from "../../utils/Utilities";
const Plans = () => {
  const [planType, setPlanType] = useState("yearly");
  const [currency, setCurrency] = useState({
    currencySymbol: "₹",
    currencyName: "Rupees",
  });

  const getCountry = async () => {
    const result = await getCurrency();
    setCurrency(result);
  };

  useEffect(() => {
    getCountry();
  }, []);

  return (
    <div id="plan" className="bigwrapper">
      <div className="sectionwrapper">
        <div className="plansdiv">
          <div className="planleft">
            <div className="planswitch">
              <button
                type="button"
                onClick={() => setPlanType("yearly")}
                className={planType === "yearly" ? "active" : ""}
              >
                Yearly Plans
              </button>
              <button
                type="button"
                onClick={() => setPlanType("monthly")}
                className={planType === "monthly" ? "active" : ""}
              >
                Monthly Plans
              </button>
            </div>
            <div>
              <h3 className="orangeheading">Pricing Chart</h3>
              <h1 className="mainsmallheading">
                Plans Designed to Grow With You
              </h1>
            </div>
            <p className="mainsmallsubheading">
              Choose the plan that fits your networking needs. Affordable,
              transparent, and built to deliver more value with every tap.
            </p>
            <div className="planswitch responsive">
              <button
                type="button"
                onClick={() => setPlanType("yearly")}
                className={planType === "yearly" ? "active" : ""}
              >
                Yearly Plans
              </button>
              <button
                type="button"
                onClick={() => setPlanType("monthly")}
                className={planType === "monthly" ? "active" : ""}
              >
                Monthly Plans
              </button>
            </div>
          </div>
          <div className="planright">
            {planType === "yearly" ? (
              <Yearly currency={currency} />
            ) : (
              <Monthly currency={currency} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
